// extracted by mini-css-extract-plugin
export default {"card":"TextEditor_card__7kdvJ","textEditorBody":"TextEditor_textEditorBody__N582Y","textEditorInnerWrapper":"TextEditor_textEditorInnerWrapper__9naaK"};